"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartesianUserInteractionTransformProvider = void 0;
/**
 * @internal
 */
class CartesianUserInteractionTransformProvider {
    constructor(plot) {
        this.plot = plot;
        this.tmpVec2 = plot.plotRange.dataRange
            .getRow(0)
            .fill(0);
        this.tmp2Vec2 = plot.plotRange.dataRange
            .getRow(0)
            .fill(0);
        this.tmpMat3 = plot.plotRange.dataRange
            .getRangeTransform(plot.plotRange.dataRange)
            .fill(0);
    }
    /**
     * Transforms `position` into the `transformedDataRange` relative to `positionRange`.
     */
    getTransformedPosition(position, positionRange) {
        // ut - user transform
        const plotRange = this.plot.plotRange;
        const positionToUtData = positionRange.getRangeTransform(plotRange.transformedDataRange, this.tmpMat3);
        return position.mat3Multiply(positionToUtData, this.tmpVec2);
    }
    getTransformedDelta(position, positionRange, dx, dy) {
        const plotRange = this.plot.plotRange;
        const positionToUtData = positionRange.getRangeTransform(plotRange.transformedDataRange, this.tmpMat3);
        this.tmp2Vec2.update(dx, dy);
        position.subtract(this.tmp2Vec2, this.tmp2Vec2);
        // position before and after in user transform space
        this.tmp2Vec2.mat3Multiply(positionToUtData, this.tmpVec2);
        position.mat3Multiply(positionToUtData, this.tmp2Vec2);
        plotRange.userTransform.reverseTransformPoint(this.tmpVec2, this.tmpVec2);
        plotRange.userTransform.reverseTransformPoint(this.tmp2Vec2, this.tmp2Vec2);
        return this.tmpVec2.subtract(this.tmp2Vec2, this.tmpVec2);
    }
}
exports.CartesianUserInteractionTransformProvider = CartesianUserInteractionTransformProvider;
//# sourceMappingURL=cartesian-user-interaction-transform-provider.js.map